import React, { useState, useEffect, useCallback } from "react";
import { useLoading } from "../../../context/LoadingContext";
import DataTable from "../../Requirement/components/common/ReusableTable";
import SearchFilter from "../../Requirement/components/common/SearchFilter";
import {
  fetchData,
  postQuery,
} from "../../../services/BackendServices";
import * as XLSX from "xlsx";
import AlertModal from "../../Requirement/components/common/AlerModel";
import {
  FormControl,
  TextField,
  Typography,
  Button,
  Select,
  MenuItem,
} from "@mui/material";
import config from "../../../aws-exports";
import { Auth } from "aws-amplify";
import { LambdaClient, InvokeCommand } from "@aws-sdk/client-lambda";
import { jwtDecode } from "jwt-decode";

const FinancePartner = () => {
  const { setLoading, loading } = useLoading();
  const [errors, setErrors] = useState({});
  // State for Finance Partners data
  const [amtplFinancePartners, setAMTPLFinancePartners] = useState([]);
  const [selectedAMTPLFinancePartner, setSelectedAMTPLFinancePartner] =
    useState(null);
  const [currentAMTPLFinancePartnerPage, setCurrentAMTPLFinancePartnerPage] =
    useState(1);
  const [totalAMTPLFinancePartnerPages, setTotalAMTPLFinancePartnerPages] =
    useState(1);

  const bucket = process.env.REACT_APP_AMTPL_BUCKET;
  let bucketfolder = "public/media/amtpl";
  const filePath = `${bucketfolder}/`;
  const fileUrl = `https://${bucket}.s3.${config.aws_project_region}.amazonaws.com/${filePath}`;

  // Filter data
  const [names, setNames] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [locations, setLocations] = useState([]);
  const [zipcodes, setZipcodes] = useState([]);
  const [countrymaster, setCountryMaster] = useState([]);

  // Filter state
  const [entitiesFilterTerms, setEntitiesFilterTerms] = useState({
    email: "",
    company: "",
    location: "",
    zipcode: "",
    status: "",
    UserType: "FinancePartner",
  });

  // Tab state
  const [activeEntitiesFinancePartnerTab, setActiveEntitiesFinancePartnerTab] =
    useState("gpDetails");

  // File upload state
  const [file, setFile] = useState(null);
  const [uploadError, setUploadError] = useState(null);

  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });

  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };

  const getBackendName = () => {
    const backend = config.aws_user_files_s3_bucket.split("-");
    return backend[backend.length - 1];
  };

  // Constants
  const pageSize = 5;

  // Required fields for validation based on GraphQL schema
  const requiredFields = [
    "AMTPLUserID",
    "EmailID",
    "GPEmailID",
    "FirstName",
    "Phone1",
    "Address1",
  ];
  // Define the status options
  const statusOptions = [
    { value: "", label: "ALL" },
    { value: "ACTIVE", label: "ACTIVE" },
    { value: "INACTIVE", label: "INACTIVE" },
  ];
  // Search fields configuration for SearchFilter component
  const fields = [
    {
      name: "email",
      label: "Name",
      type: "dropdown",
      options: [
        { value: "", label: "Select Name" },
        ...names.map((name) => {
          const match = name.match(/<([^>]+)>/);
          const keyAndValue = match ? match[1].trim() : "";
          return {
            value: keyAndValue,
            label: name,
          };
        }),
      ],
      value: entitiesFilterTerms.email,
      onChange: (value) => {
        setEntitiesFilterTerms((prev) => ({ ...prev, email: value }));
      },
    },
    {
      name: "company",
      label: "Company",
      type: "dropdown",
      options: [
        { value: "", label: "Select Company" },
        ...companies.map((company) => ({
          value: company,
          label: company,
        })),
      ],
      value: entitiesFilterTerms.company,
      onChange: (value) => {
        setEntitiesFilterTerms((prev) => ({ ...prev, company: value }));
      },
    },
    // {
    //   name: "location",
    //   label: "Location",
    //   type: "dropdown",
    //   options: [
    //     { value: "", label: "Select Location" },
    //     ...locations.map((location) => ({
    //       value: location,
    //       label: location,
    //     })),
    //   ],
    //   value: entitiesFilterTerms.location,
    //   onChange: (value) => {
    //     setEntitiesFilterTerms((prev) => ({ ...prev, location: value }));
    //   },
    // },
    {
      name: "zipcode",
      label: "Zipcode",
      type: "dropdown",
      options: [
        { value: "", label: "Select Zipcode" },
        ...zipcodes.map((zipcode) => ({
          value: zipcode,
          label: zipcode,
        })),
      ],
      value: entitiesFilterTerms.zipcode,
      onChange: (value) => {
        setEntitiesFilterTerms((prev) => ({ ...prev, zipcode: value }));
      },
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      options: statusOptions,
      value: entitiesFilterTerms.status,
      onChange: (value) => {
        setEntitiesFilterTerms((prev) => ({ ...prev, status: value }));
      },
    },
  ];

  // Define table columns for DataTable
  const columns = [
    {
      id: "AMTPLUserID",
      numeric: false,
      label: "Partner Id",
      renderCell: (row) => row.AMTPLUserID || "N/A",
    },
    {
      id: "PartnerName",
      numeric: false,
      label: "Partner Name",
      renderCell: (row) =>
        `${row.FirstName || ""} ${row.LastName || ""}`.trim() || "N/A",
    },
    {
      id: "CompanyName",
      numeric: false,
      label: "Company",
      renderCell: (row) => row.CompanyName || "N/A",
    },
    {
      id: "Country",
      numeric: false,
      label: "Country",
      renderCell: (row) => row.Country || "N/A",
    },
    {
      id: "State",
      numeric: false,
      label: "State",
      renderCell: (row) => row.State || "N/A",
    },
    {
      id: "Phone1",
      numeric: false,
      label: "Phone",
      renderCell: (row) => row.Phone1 || "N/A",
    },
    {
      id: "EmailID",
      numeric: false,
      label: "Email",
      renderCell: (row) => row.EmailID || "N/A",
    },
    {
      id: "Status",
      numeric: false,
      label: "Status",
      renderCell: (row) => {
        let bgColor = "";
        let textColor = "";

        switch (row.Status) {
          case "INACTIVE":
            bgColor = "#f85d4f25";
            textColor = "#e2461fff";
            break;
          case "ACTIVE":
            bgColor = "#d1fae5";
            textColor = "#065f46";
            break;
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "999px",
              fontSize: "10px",
              fontWeight: 500,
            }}
          >
            {row.Status}
          </span>
        );
      },
    },
  ];

  // Fetch filter options from all records
  const fetchFilterOptions = useCallback(async () => {
    setLoading(true);
    try {
      //   const body = {
      //     target: "listAMTPLUsersAdm",
      //     option: "financepartner",
      //     filterTerms: {},
      //     rowStart: 0,
      //     pageSize: 10000, // Large number to fetch all
      //   };

      const body = {
        target: "listAMTPLUsers",
        filterTerms: { UserType: "FinancePartner" },
        rowStart: 0,
        pageSize: 10000, // Large number to fetch all
      };

      const result = await fetchData(body);
      console.log(result, "fetchoption");
      if (result && (result.items || result.statusCode === 200)) {
        const partners = result.items || [];
        if (partners.length > 0) {
          const uniqueNames = [
            ...new Set(
              partners
                .map((p) =>
                  `${p.FirstName || ""} ${p.LastName || ""} <${
                    p.EmailID || ""
                  }>`.trim()
                )
                .filter((name) => name !== "<>")
            ),
          ];
          const uniqueCompanies = [
            ...new Set(partners.map((p) => p.CompanyName).filter(Boolean)),
          ];
          const uniqueLocations = [
            ...new Set(partners.map((p) => p.State).filter(Boolean)),
          ];
          const uniqueZipcodes = [
            ...new Set(partners.map((p) => p.ZipCode).filter(Boolean)),
          ];

          setNames(uniqueNames);
          setCompanies(uniqueCompanies);
          setLocations(uniqueLocations);
          setZipcodes(uniqueZipcodes);
        } else {
          setNames([]);
          setCompanies([]);
          setLocations([]);
          setZipcodes([]);
        }
      } else {
        console.error("Error fetching filter options: ", result);
        setNames([]);
        setCompanies([]);
        setLocations([]);
        setZipcodes([]);
      }
    } catch (error) {
      console.error("Error fetching filter options: ", error);
      setNames([]);
      setCompanies([]);
      setLocations([]);
      setZipcodes([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  // Fetch AMTPL Finance Partners (paginated)
  const fetchAMTPLUsers = useCallback(
    async (customParams = {}) => {
      setLoading(true);
      try {
        console.log("entitiesFilterTerms@@", entitiesFilterTerms);
        const { email, ...rest } = entitiesFilterTerms;

        const filterTerms = {
          ...rest,
          EmailID: email, // rename key
          ...customParams.filterTerms,
        };
        if (filterTerms.status === "") {
          delete filterTerms.status; // Remove status filter for ALL
        }
        // const body = {
        //   target: "listAMTPLUsersAdm",
        //   option: "financepartner",
        //   filterTerms: filterTerms,
        //   rowStart:
        //     customParams.rowStart ||
        //     (currentAMTPLFinancePartnerPage - 1) * pageSize,
        //   pageSize: pageSize,
        //   ...customParams,
        // };
        const body = {
          target: "listAMTPLUsers",
          //   option: "financepartner",
          filterTerms: filterTerms,
          rowStart:
            customParams.rowStart ||
            (currentAMTPLFinancePartnerPage - 1) * pageSize,
          pageSize: pageSize,
          ...customParams,
        };

        const result = await fetchData(body);
        console.log(result, "fetch");
        if (result && (result.items || result.statusCode === 200)) {
          const partners = result.items || [];

          const modifiedItems = (result.items || result).map((item) => ({
            ...item,
            id: item.AMTPLUserID, // Add id property with value from RequirementsID
          }));
          setAMTPLFinancePartners(modifiedItems);
          setTotalAMTPLFinancePartnerPages(
            Math.ceil((result.total || partners.length) / pageSize)
          );
        } else {
          console.error("Error fetching Finance Partners: ", result);
          setAMTPLFinancePartners([]);
          setTotalAMTPLFinancePartnerPages(1);
        }
      } catch (error) {
        console.error("Error fetching Finance Partners: ", error);
        setAMTPLFinancePartners([]);
        setTotalAMTPLFinancePartnerPages(1);
      } finally {
        setLoading(false);
      }
    },
    [currentAMTPLFinancePartnerPage, entitiesFilterTerms, setLoading]
  );

  // Validate Excel data against required fields
  const validateExcelData = (data) => {
    for (let i = 0; i < data.length; i++) {
      const row = data[i];
      for (const field of requiredFields) {
        if (!row[field] || row[field].toString().trim() === "") {
          return `Missing required field "${field}" in row ${i + 2}`;
        }
      }
      // Optional: Add additional validation (e.g., email format, integer for Age)
      if (row.EmailID && !/\S+@\S+\.\S+/.test(row.EmailID)) {
        return `Invalid email format for EmailID in row ${i + 2}`;
      }
      if (row.GPEmailID && !/\S+@\S+\.\S+/.test(row.GPEmailID)) {
        return `Invalid email format for GPEmailID in row ${i + 2}`;
      }
      if (row.Age && !Number.isInteger(Number(row.Age))) {
        return `Invalid Age (must be an integer) in row ${i + 2}`;
      }
    }
    return null;
  };

  // Handle file selection
  const handleFileChange = (event) => {
    console.log("hFileChange@@", event.target.files[0]);
    setFile(event.target.files[0]);
    setUploadError(null);
  };

  // Load countries
  const loadCountries = useCallback(async () => {
    setLoading(true);
    try {
      const [allCountries] = await Promise.all([
        fetchData({
          target: "listDropDownOptions",
          userOrder: "Value",
          rowStart: 0,
          pageSize: 1000,
          filterTerms: { Type: "Country" },
        }),
      ]);
      if (allCountries.items.length > 0) {
        setCountryMaster(allCountries.items);
      } else {
        setCountryMaster([]);
      }
    } catch (error) {
      console.error("Error loading countries: ", error);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  // Handle Excel file upload and processing
  const handleUpload = async () => {
    if (!file) {
      setUploadError("Please select a file to upload.");
      return;
    }

    setLoading(true);
    setUploadError(null);

    try {
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          // Parse Excel file
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const parsedData = XLSX.utils.sheet_to_json(sheet);

          console.log("Parsed Excel Data:", parsedData);

          if (parsedData.length === 0) {
            setUploadError("The uploaded file is empty.");
            setLoading(false);
            return;
          }

          const bankMasterResponse = await fetchData({
            target: "listBankMaster",
            userOrder: "BankName",
            rowStart: 0,
            pageSize: 10000,
          });
          console.log("bankMasterResponse###", bankMasterResponse);
          const bankMasterData = bankMasterResponse.items;
          console.log("bankMasterData@@@", bankMasterData);

          const bankMap = new Map(
            bankMasterData.map((bank) => [bank.BankName, bank.BankID])
          );
          // Transform parsedData: remove Bank column and add OrgId
          const updatedData = parsedData.map((row) => {
            const { Bank, ...rest } = row; // Remove Bank column
            return {
              ...rest,
              OrgId: bankMap.get(Bank) || 0, // Add OrgId (null if BankName not found)
            };
          });

          console.log("updatedData@@@", updatedData);

          //   return;
          // Send data to backend
          const body = {
            target: "importAMTPLUsers",
            option: "FinancePartner",
            usersData: updatedData,
          };

          console.log("Request Body:", body);
          const result = await postQuery(body, "backendops");

          if (result) {
            console.log("Excel data imported successfully");

            // Refresh the data
            setModal({
              show: true,
              type: "success",
              title: "Success!",
              message: `Excel data imported successfully.`,
              autoClose: false,
              nextAction: () => {
                setFile(null);
                document.getElementById("fileInput").value = "";
              },
            });
            await fetchAMTPLUsers();
            await fetchFilterOptions();
          } else {
            setUploadError("Failed to import data. Please try again.");
            console.error("Error importing Excel data: ", result);
          }
        } catch (error) {
          console.error("Error in file processing:", error);
          let errorMessage =
            "An unexpected error occurred while processing the file. Please try again or contact support.";

          try {
            // Handle API response with nested JSON string in body
            console.log("in error try1 block");
            if (error && !error.errors) {
              console.log("in error body block", error.error);
              errorMessage = error.error;
            }
            // Optional: Handle validation errors from backend (like missing Group Name)
            else if (error.errors && Array.isArray(error.errors)) {
              const failedEmails = error.errors
                .map((err) => err.email)
                .join(", ");
              errorMessage =`The following records could not be processed: ${failedEmails}.`;
            }
          } catch (err) {
            console.error("Error processing error response:", err);
            // Keep default message if all parsing fails
          }

          setUploadError(errorMessage);
        } finally {
          setLoading(false);
        }
      };

      reader.onerror = () => {
        console.error("FileReader error occurred");
        setUploadError("Error reading the file. Please try again.");
        setLoading(false);
      };

      reader.readAsArrayBuffer(file);
    } catch (error) {
      console.error("Error initiating file upload:", error);
      setUploadError("Error uploading file. Please try again.");
      setLoading(false);
    }
  };

  // Handle search for SearchFilter component
  const handleSearchFilter = (searchValues) => {
    setEntitiesFilterTerms(searchValues);
    setCurrentAMTPLFinancePartnerPage(1);
    console.log("searchValues@@", searchValues);
    fetchAMTPLUsers({ filterTerms: searchValues, rowStart: 0 });
  };

  const handleAMTPLFinancePartnerRowClick = (partner) => {
    setSelectedAMTPLFinancePartner(partner);
  };

  const handleEntitiesFinancePartnerTabClick = (tab) => {
    setActiveEntitiesFinancePartnerTab(tab);
  };

  const handleAMTPLFinancePartnerChange = (e) => {
    const { id, name, value } = e.target;
    const field = id || name; // Use id for inputs, name for Select
    setSelectedAMTPLFinancePartner((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleFinancePartnerSave = async () => {
    if (!selectedAMTPLFinancePartner) return;
    selectedAMTPLFinancePartner.Address1 =
      selectedAMTPLFinancePartner.Address1 || " ";
    selectedAMTPLFinancePartner.AgropreneurDetailsID =
      selectedAMTPLFinancePartner.AgropreneurDetailsID || " ";

    setLoading(true);
    try {
      let recordStatus = selectedAMTPLFinancePartner.Status || "INACTIVE";
      const userStatusResponse = await postQuery(
        {
          target: "changeUserStatus",
          Input: {
            userEmailAddress: selectedAMTPLFinancePartner.EmailID,
            newStatus: recordStatus,
          },
        },
        "backendops"
      );
      const body = {
        target: "updateAMTPLUser",
        updateAMTPLUserInput: {
          AMTPLUserID: selectedAMTPLFinancePartner.AMTPLUserID,
          EmailID: selectedAMTPLFinancePartner.EmailID,
          FirstName: selectedAMTPLFinancePartner.FirstName || "",
          LastName: selectedAMTPLFinancePartner.LastName || "",
          Country: selectedAMTPLFinancePartner.Country || "",
          State: selectedAMTPLFinancePartner.State || "",
          Phone1: selectedAMTPLFinancePartner.Phone1 || " ",
          Address1: selectedAMTPLFinancePartner.Address1 || " ",
          CompanyName: selectedAMTPLFinancePartner.CompanyName || "",
          CompanyZipCode: selectedAMTPLFinancePartner.CompanyZipCode || "",
          CompanyPhone1: selectedAMTPLFinancePartner.CompanyPhone1 || "",
          CompanyAddress1: selectedAMTPLFinancePartner.CompanyAddress1 || "",
          Status: recordStatus,
        },
      };

      const result = await postQuery(body);

      if (result) {
        console.log("Finance Partner updated successfully");
        // Refresh the data
        setModal({
          show: true,
          type: "success",
          title: "Success!",
          message: `Finance Partner updated successfully.`,
          autoClose: false,
          nextAction: () => {
            setFile(null);
            document.getElementById("fileInput").value = "";
          },
        });
        await fetchAMTPLUsers();
        await fetchFilterOptions();
      } else {
        console.error("Error updating Finance Partner");
        setModal({
          show: true,
          type: "error",
          title: "Error!",
          message: "Error happened updating Finance Partner.",
          autoClose: false,
        });
      }
    } catch (error) {
      console.error("Error updating Finance Partner:", error);
      setModal({
        show: true,
        type: "error",
        title: "Error!",
        message: error.message || "Error updating Finance Partner.",
        autoClose: false,
      });
    } finally {
      setLoading(false);
    }
  };

  // DataTable handlers
  const handlePageChange = useCallback((page) => {
    setCurrentAMTPLFinancePartnerPage(page);
  }, []);

  const handleRowClick = useCallback((row) => {
    handleAMTPLFinancePartnerRowClick(row);
  }, []);

  const resetPassword = async (selectedAMTPLUser) => {
    if (!selectedAMTPLUser) {
      console.error("No user selected");
      return;
    }

    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

      const body = {
        target: "activate_amtpluser",
        option: "financepartner",
        access_token: user.signInUserSession.idToken.jwtToken,
        amtplUser: selectedAMTPLUser,
      };

      const params = {
        FunctionName: `backendops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));

      if (result.statusCode === 200) {
        console.log(`Save action successful`, result);
        const bodyAMTPLUser = {
          target: "updateAMTPLUser",
          updateAMTPLUserInput: {
            AMTPLUserID: selectedAMTPLFinancePartner.AMTPLUserID,
            EmailID: selectedAMTPLFinancePartner.EmailID,
            FirstName: selectedAMTPLFinancePartner.FirstName || "",
            LastName: selectedAMTPLFinancePartner.LastName || "",
            Country: selectedAMTPLFinancePartner.Country || "",
            State: selectedAMTPLFinancePartner.State || "",
            Phone1: selectedAMTPLFinancePartner.Phone1 || " ",
            Address1: selectedAMTPLFinancePartner.Address1 || " ",
            CompanyName: selectedAMTPLFinancePartner.CompanyName || "",
            CompanyZipCode: selectedAMTPLFinancePartner.CompanyZipCode || "",
            CompanyPhone1: selectedAMTPLFinancePartner.CompanyPhone1 || "",
            CompanyAddress1: selectedAMTPLFinancePartner.CompanyAddress1 || "",
            Status: "ACTIVE",
          },
        };
        const resultAMTPLUser = await postQuery(bodyAMTPLUser);

        if (resultAMTPLUser) {
          console.log("Finance Partner updated successfully");
          setModal({
            show: true,
            type: "success",
            title: "Success!",
            message: `Finance Partner activated successfully. Password mail has been sent to registered email.`,
            autoClose: false,
            nextAction: () => {
              setFile(null);
              document.getElementById("fileInput").value = "";
            },
          });
          await fetchAMTPLUsers();
          await fetchFilterOptions();
        } else {
          console.error("Error updating Finance Partner");
          setModal({
            show: true,
            type: "error",
            title: "Error!",
            message: "Error happened updating Finance Partner.",
            autoClose: false,
          });
        }
      } else {
        console.error(`Error updating User: ${JSON.stringify(result)}`);
        setModal({
          show: true,
          type: "error",
          title: "Error!",
          message: `Error updating User: ${JSON.stringify(result)}`,
          autoClose: false,
        });
      }
    } catch (error) {
      console.error(`Error updating User: ${JSON.stringify(error)}`);
      setModal({
        show: true,
        type: "error",
        title: "Error!",
        message: `Error updating User: ${JSON.stringify(error)}`,
        autoClose: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleGPResetPassword = async () => {
    resetPassword(selectedAMTPLFinancePartner);
  };

  // Load data on component mount
  useEffect(() => {
    fetchFilterOptions();
    loadCountries();
  }, [fetchFilterOptions, loadCountries]);

  // Load paginated data on page change or filter change
  useEffect(() => {
    fetchAMTPLUsers();
  }, [fetchAMTPLUsers, currentAMTPLFinancePartnerPage]);

  const Button = ({ label, onClick }) => {
    return (
      <button className="submit-btn-more" onClick={onClick}>
        {label}
      </button>
    );
  };
  return (
    <div className="buyer-dashboard  p-3">
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <div className="card">
        <div className="row">
          <div className="col-12">
            <div className="card p-4">
              <h4 className="text-center mb-3">Import Data</h4>
              <div className="alert alert-info mb-4 text-center" role="alert">
                To ensure a smooth import, please download our sample format
                first. This will help you structure your data correctly.
              </div>

              {/* Horizontal Layout */}
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                {/* Download Button */}
                <div className="text-center">
                  <a
                    href={`${fileUrl}sampleformat/SampleFormatFinancePartner.xlsx`}
                    className="btn btn-primary"
                  >
                    {" "}
                    Download Sample Format
                  </a>
                  <small className="text-muted d-block mt-1">
                    (.xlsx format)
                  </small>
                </div>

                {/* File Upload */}
                <div className="text-center">
                  <label
                    htmlFor="fileInput"
                    className="submit-btn"
                    style={{ border: "dashed 1px #ccc", minWidth: "180px" }}
                  >
                    Upload Your File
                  </label>
                  <input
                    type="file"
                    id="fileInput"
                    onChange={handleFileChange}
                    accept=".csv,.xlsx,.xls"
                    className="d-none"
                  />{" "}
                  {file?.name}
                  {uploadError && (
                    <div className="text-danger mt-2 small">{uploadError}</div>
                  )}
                </div>

                {/* Import Button */}
                <div className="text-center">
                  <button
                    onClick={handleUpload}
                    className="submit-btn-more"
                    disabled={!file}
                    style={{ minWidth: "180px" }}
                  >
                    Import
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Finance Partners Table */}
        <div className="card5">
          {/* Search Filters */}
          <div className="search-filter4 ">
            <div className="title4">
              <div className="head-text text-xl font-semibold">
                Finance Partner
              </div>
            </div>
            <div className="filter4">
              <SearchFilter fields={fields} onSearch={handleSearchFilter} />
            </div>
          </div>
          {loading && (
            <div className="loading text-center text-gray-500">
              Loading Finance Partners...
            </div>
          )}
          {!loading && amtplFinancePartners.length === 0 && (
            <div className="empty-state text-center text-gray-500">
              No Finance Partners available
            </div>
          )}
          {!loading && amtplFinancePartners.length > 0 && (
            <DataTable
              columns={columns}
              data={amtplFinancePartners}
              total={totalAMTPLFinancePartnerPages * pageSize}
              title="Finance Partners Information"
              rowsPerPage={pageSize}
              onPageChange={handlePageChange}
              onRowClick={handleRowClick}
              currentPage={currentAMTPLFinancePartnerPage}
              selectedRows={
                selectedAMTPLFinancePartner
                  ? [selectedAMTPLFinancePartner.id]
                  : []
              }
            />
          )}
          {/* Finance Partner Details Section */}
          {selectedAMTPLFinancePartner && (
            <div className="row ">
              <div className="button-group">
                <Button
                  label="Update"
                  disabled={!selectedAMTPLFinancePartner}
                  onClick={handleFinancePartnerSave}
                />
                <Button
                  label="Generate & Send Password"
                  disabled={!selectedAMTPLFinancePartner}
                  onClick={handleGPResetPassword}
                />
              </div>
              <section>
                <div className="tabs flex border-b">
                  <button
                    className={
                      activeEntitiesFinancePartnerTab === "gpDetails"
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      handleEntitiesFinancePartnerTabClick("gpDetails")
                    }
                  >
                    Partner Details
                  </button>
                  <button
                    className={
                      activeEntitiesFinancePartnerTab === "companyDetails"
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      handleEntitiesFinancePartnerTabClick("companyDetails")
                    }
                  >
                    Company Details
                  </button>
                </div>

                {activeEntitiesFinancePartnerTab === "gpDetails" && (
                  <div className="tab-content active">
                    <div className="row">
                      <div className="col-lg-12 col-sm-12 col-12">
                        <div className="row">
                          <div className="col-lg-3 col-sm-4 col-6">
                            <label htmlFor="FirstName">First Name</label>
                            <input
                              id="FirstName"
                              type="text"
                              className="form-control"
                              value={
                                selectedAMTPLFinancePartner?.FirstName || ""
                              }
                              onChange={handleAMTPLFinancePartnerChange}
                            />
                          </div>
                          <div className="col-lg-3 col-sm-4 col-6">
                            <label htmlFor="LastName">Last Name</label>
                            <input
                              id="LastName"
                              type="text"
                              className="form-control"
                              value={
                                selectedAMTPLFinancePartner?.LastName || ""
                              }
                              onChange={handleAMTPLFinancePartnerChange}
                            />
                          </div>
                          <div className="col-lg-3 col-sm-4 col-6">
                            <label htmlFor="EmailID">Email ID</label>
                            <input
                              id="EmailID"
                              type="email"
                              readOnly="true"
                              className="form-control"
                              value={selectedAMTPLFinancePartner?.EmailID || ""}
                              onChange={handleAMTPLFinancePartnerChange}
                            />
                          </div>
                          <div className="col-lg-3 col-sm-4 col-6">
                            <label htmlFor="Phone1">Phone</label>
                            <input
                              id="Phone1"
                              type="text"
                              className="form-control"
                              value={selectedAMTPLFinancePartner?.Phone1 || ""}
                              onChange={handleAMTPLFinancePartnerChange}
                            />
                          </div>
                          <div className="col-lg-3 col-sm-4 col-6">
                            <FormControl
                              sx={{ minWidth: "100%" }}
                              error={!!errors.Country}
                            >
                              <Typography variant="body2">Country</Typography>
                              <Select
                                name="Country"
                                value={
                                  selectedAMTPLFinancePartner?.Country || ""
                                }
                                onChange={handleAMTPLFinancePartnerChange}
                                displayEmpty
                                sx={{ backgroundColor: "white" }}
                                inputProps={{ "aria-label": "Select Country" }}
                                error={!!errors.Country}
                              >
                                <MenuItem value="" disabled>
                                  Select country
                                </MenuItem>
                                {countrymaster.map((p) => (
                                  <MenuItem key={p.ID} value={p.Value}>
                                    {p.Value}
                                  </MenuItem>
                                ))}
                              </Select>
                              {errors.Country && (
                                <Typography variant="caption" color="error">
                                  {errors.Country}
                                </Typography>
                              )}
                            </FormControl>
                          </div>
                          <div className="col-lg-3 col-sm-4 col-6">
                            <label htmlFor="State">State</label>
                            <input
                              id="State"
                              type="text"
                              className="form-control"
                              value={selectedAMTPLFinancePartner?.State || ""}
                              onChange={handleAMTPLFinancePartnerChange}
                            />
                          </div>
                          <div className="col-lg-3 col-sm-4 col-6">
                            <FormControl
                              sx={{ minWidth: "100%" }}
                              error={!!errors.Status}
                            >
                              <Typography variant="body2">Status</Typography>
                              <Select
                                name="Status"
                                value={selectedAMTPLFinancePartner?.Status}
                                onChange={handleAMTPLFinancePartnerChange}
                                displayEmpty
                                sx={{ backgroundColor: "white" }}
                                inputProps={{
                                  "aria-label": "Select Product Category",
                                }}
                              >
                                <MenuItem value="" disabled>
                                  Select Status
                                </MenuItem>
                                <MenuItem value="ACTIVE">ACTIVE</MenuItem>
                                <MenuItem value="INACTIVE">INACTIVE</MenuItem>
                              </Select>
                              {errors.Status && (
                                <Typography variant="caption" color="error">
                                  {errors.Status}
                                </Typography>
                              )}
                            </FormControl>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {activeEntitiesFinancePartnerTab === "companyDetails" && (
                  <div className="tab-content active">
                    <div className="row">
                      <div className="col-lg-12 col-sm-12 col-12">
                        <div className="row">
                          <div className="col-lg-6 col-sm-8 col-12">
                            <label htmlFor="CompanyName">Company Name</label>
                            <input
                              id="CompanyName"
                              type="text"
                              className="form-control"
                              value={
                                selectedAMTPLFinancePartner?.CompanyName || ""
                              }
                              onChange={handleAMTPLFinancePartnerChange}
                            />
                          </div>
                          <div className="col-lg-6 col-sm-8 col-12">
                            <label htmlFor="CompanyPhone1">Phone</label>
                            <textarea
                              id="CompanyPhone1"
                              className="form-control"
                              rows="3"
                              value={
                                selectedAMTPLFinancePartner?.CompanyPhone1 || ""
                              }
                              onChange={handleAMTPLFinancePartnerChange}
                            />
                          </div>
                          <div className="col-lg-6 col-sm-8 col-12">
                            <label htmlFor="CompanyAddress1">Address</label>
                            <textarea
                              id="CompanyAddress1"
                              className="form-control"
                              rows="3"
                              value={
                                selectedAMTPLFinancePartner?.CompanyAddress1 ||
                                ""
                              }
                              onChange={handleAMTPLFinancePartnerChange}
                            />
                          </div>
                          <div className="col-lg-3 col-sm-4 col-6">
                            <label htmlFor="CompanyZipCode">Zip Code</label>
                            <input
                              id="CompanyZipCode"
                              type="text"
                              className="form-control"
                              value={
                                selectedAMTPLFinancePartner?.CompanyZipCode ||
                                ""
                              }
                              onChange={handleAMTPLFinancePartnerChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </section>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FinancePartner;
